<template>
  <div class="w-100 mt-3 progress-wrap">
    <div class="mb-1">
      <span class="text-keyword">
        {{ data.nameKeyword }}
      </span>
    </div>
    <div class="progress-wrap">
      <div>
        <b-progress
          :value="data.percent"
          max="100"
          height="2.5rem"
          class="mb-1"
        >
          <b-progress-bar
            :value="data.percent"
            :label-html="`${data.percent}%`"
            class="font-weight-bold"
          ></b-progress-bar>
        </b-progress>
      </div>
      <div :class="['text-count', { 'text-white': data.percent > 80 }]">
        <span class="font-weight-bold"> {{ data.countWord }} ครั้ง </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-wrap {
  position: relative;
}

.text-keyword {
  overflow: hidden;
  font-weight: bold;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin: auto;
}

.text-count {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-50%, -50%);
}

::v-deep .progress-bar {
  background-image: linear-gradient(to right, #8f20c6, #5cb7d9);
}

::v-deep .progress {
  background-color: #e2dff3;
}
</style>
